/**
 * Shared menu-flow card layout constants (set2 / v2 chrome).
 *
 * Geometry is border-aware: the card shell draws a `MENU_FLOW_ITEM_CARD_BORDER_WIDTH`
 * stroke inside `MENU_FLOW_ITEM_CARD_HEIGHT`. Image gap is measured from the inner
 * edge of that border so top / left / bottom spacing stays pixel-equal in the UI.
 */

/** Card body height (excludes vertical margin). */
export const MENU_FLOW_ITEM_CARD_HEIGHT = 144;
/** Vertical margin above and below each card. */
export const MENU_FLOW_ITEM_CARD_MARGIN_VERTICAL = 8;
/** Total row height: card + margins. */
export const MENU_FLOW_ITEM_ROW_HEIGHT = MENU_FLOW_ITEM_CARD_HEIGHT + 2 * MENU_FLOW_ITEM_CARD_MARGIN_VERTICAL;

/** Card shell border — keep in sync with `MenuFlowItemCardSet2` jelly border width. */
export const MENU_FLOW_ITEM_CARD_BORDER_WIDTH = 1;

/** Inner content height inside the card border. */
export const MENU_FLOW_ITEM_CARD_INNER_HEIGHT =
  MENU_FLOW_ITEM_CARD_HEIGHT - 2 * MENU_FLOW_ITEM_CARD_BORDER_WIDTH;

/**
 * Gap from the inner card edge (below the border) to the image on top, left, and bottom.
 * Outer visual inset = border + gap (e.g. 1 + 4 = 5px from card outer edge).
 */
export const MENU_FLOW_ITEM_IMAGE_GAP = 4;

/** Square image side — fills inner height minus top/bottom gap. */
export const MENU_FLOW_ITEM_IMAGE_SIZE = MENU_FLOW_ITEM_CARD_INNER_HEIGHT - 2 * MENU_FLOW_ITEM_IMAGE_GAP;

/** Alias kept for existing imports. */
export const MENU_FLOW_ITEM_IMAGE_WIDTH = MENU_FLOW_ITEM_IMAGE_SIZE;

/** Image column width: left gap + image (right edge meets content column). */
export const MENU_FLOW_ITEM_IMAGE_SECTION_WIDTH = MENU_FLOW_ITEM_IMAGE_GAP + MENU_FLOW_ITEM_IMAGE_SIZE;

export const MENU_FLOW_ITEM_CONTENT_PADDING_H = 5;
/** Bottom padding for the text column (keeps footer anchored). */
export const MENU_FLOW_ITEM_CONTENT_PADDING_V = MENU_FLOW_ITEM_IMAGE_GAP;
/**
 * Extra top inset so title/description sit below the image top edge
 * (not flush with the image frame).
 */
export const MENU_FLOW_ITEM_CONTENT_PADDING_TOP = MENU_FLOW_ITEM_IMAGE_GAP + 16;
export const MENU_FLOW_ITEM_BOTTOM_ROW_MIN_HEIGHT = 36;
export const MENU_FLOW_ITEM_TITLE_MIN_HEIGHT = 22;

/** Unselected card image corner radius. */
export const MENU_FLOW_ITEM_IMAGE_BORDER_RADIUS = 21;
/** Badge offset from the image frame edge (not the card shell). */
export const MENU_FLOW_ITEM_BADGE_INSET = 5;
export const MENU_FLOW_ITEM_TITLE_FONT_SIZE = 16;
export const MENU_FLOW_ITEM_DESC_FONT_SIZE = 12;
